import React from "react";
import { Hourglass } from "lucide-react";

import { formatCurrency, formatInt, formatPct } from "@/features/relatorio-vendas/lib/formato";

import { formatarDecimal } from "../regras";
import { Secao } from "./Base";

/**
 * Quantas vendas caem em cada faixa de tempo, e o ticket médio de cada uma:
 * mostra se ficar mais tempo vira mais consumo (mesas) ou se a demora é rara
 * (entregas). Barras em HTML — a faixa com mais vendas fica cheia.
 */
export default function Faixas({ faixas, titulo = "Quanto tempo leva", explicacao, comPessoas = false, e2e = "faixas" }) {
  const total = (faixas || []).reduce((s, f) => s + f.vendas, 0);
  if (!total) return null;
  const maximo = Math.max(...faixas.map((f) => f.vendas));
  return (
    <Secao titulo={titulo} icone={Hourglass} explicacao={explicacao} e2e={e2e}>
      <div className="space-y-2.5">
        {faixas.map((f) => {
          const pct = (f.vendas / total) * 100;
          return (
            <div key={f.rotulo} className="grid grid-cols-[88px_1fr] sm:grid-cols-[104px_1fr_auto] items-center gap-x-3 gap-y-0.5">
              <span className="text-xs font-medium">{f.rotulo}</span>
              <div className="h-6 rounded-md bg-muted/50 overflow-hidden">
                <div className={`h-full rounded-md flex items-center px-2 text-[11px] font-bold text-primary-foreground whitespace-nowrap ${f.vendas === maximo ? "bg-primary" : "bg-primary/60"}`}
                  style={{ width: `${Math.max(pct, f.vendas ? 2 : 0)}%` }}>
                  {pct >= 12 ? formatPct(pct, 0) : ""}
                </div>
              </div>
              <span className="col-start-2 sm:col-start-auto text-[11px] text-muted-foreground tabular-nums sm:text-right sm:min-w-[210px]">
                {formatInt(f.vendas)} {f.vendas === 1 ? "venda" : "vendas"}{pct < 12 && f.vendas ? ` (${formatPct(pct, 0)})` : ""}
                {f.vendas > 0 && <> · ticket <b className="text-foreground">{formatCurrency(f.ticket_medio)}</b></>}
                {comPessoas && f.pessoas_media != null && <> · {formatarDecimal(f.pessoas_media)} pessoas</>}
              </span>
            </div>
          );
        })}
      </div>
    </Secao>
  );
}
